import { mapActions } from 'vuex';
import constants from '@/constants';
import { isDebugOn } from '@/logger';

const levels = [
  'success',
  'danger',
  'warning',
  'info',
];

export default {
  props: {
    level: {
      type: String,
      default: 'success',
      validator: value => levels.indexOf(value) !== -1,
    },
    autoClose: {
      type: Boolean,
      required: false,
      default: true,
    },
    closeTimeout: {
      type: Number,
      required: false,
      default: constants.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT,
    },
    onCloseCallback: {
      default: null,
    },
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      interacted: false,
    };
  },
  computed: {
    showIcon() {
      return ['danger', 'success'].includes(this.level);
    },
    contentModifiers() {
      return {
        'side-notification__content': true,
        [`side-notification__content--${this.level}`]: this.level,
      };
    },
  },
  methods: {
    ...mapActions('notifications', ['clearSideNotification']),
    onClose() {
      this.clearSideNotification();
      if ((typeof this.onCloseCalback !== 'undefined') && (this.oncloseCallback !== null)) {
        this.onCloseCalback.apply(this);
      }
    },
    onInteract() {
      this.interacted = true;
    },
  },
  mounted() {
    this.$el.addEventListener('click', () => this.onInteract());
    if (this.autoClose && !isDebugOn()) {
      this.timeout = setTimeout(() => {
        this.onClose();
      }, this.closeTimeout);
    }
  },
  beforeDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/generics/side-notification/side-notification.js